// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';
import { domBind } from '../../lib/dom-event';
import window from 'window-or-global';

const initToolbar = function () {
	const Editor = window.Confluence.Editor;
	return {
		initContextToolbars(e, editor) {
			/**
			 * A utility function for IE and Firefox specifically that will move the cursor to the
			 * end of the supplied textbox control.
			 *
			 * Webkit has a more sensible behaviour on focus so doesn't need this.
			 */
			const moveCursorToEnd = function (textbox) {
				if (window.tinymce.Env.ie) {
					const range = textbox.createTextRange();
					range.execCommand('SelectAll');
					range.move('textedit');
					range.select();
				} else if (window.tinymce.Env.gecko) {
					const length = $(textbox).val().length;
					textbox.setSelectionRange(length, length);
				}
			};

			const focusOnButton = function (cssClass) {
				top.focus();
				window.tinymce.activeEditor.plugins.customtoolbar.focusToolbarButton(cssClass);
			};

			const focusOnFindTextBox = function () {
				top.focus();
				const textBox = $('#search-toolbar-find-text');
				textBox.focus();
				moveCursorToEnd(textBox[0]);
			};

			const focusOnReplaceTextBox = function () {
				top.focus();
				const textBox = $('#search-toolbar-replace-text');
				textBox.focus();
				moveCursorToEnd(textBox[0]);
			};

			const focusOnEditor = function () {
				if (window.tinymce.Env.ie) {
					frames['wysiwygTextarea_ifr'].focus();
				}

				if (window.tinymce.Env.ie || window.tinymce.Env.gecko) {
					const ed = window.tinymce.activeEditor;
					ed.focus();
					ed.selection.select(ed.getBody());
					ed.selection.collapse(false);
					ed.focus();
				}
			};

			// keyboard handling for the find text box
			const findKeyboardHandler = function (e) {
				if (
					!window.tinymce.isIE8 &&
					(e.ctrlKey || (window.tinymce.isMac && e.metaKey)) &&
					e.which === 70
				) {
					// prevent browser search from kicking in
					e.preventDefault();
				} else if (e.which === 13) {
					e.preventDefault();
					const parameters = {
						backwards: false,
						onFound: focusOnFindTextBox,
						onNotFound: focusOnFindTextBox,
					};
					window.tinymce.activeEditor.undoManager.ignore(() => {
						window.tinymce.activeEditor.execCommand('mceConfSearch', false, parameters, {
							skip_undo: true,
						});
					});
				} else if (e.which === 27) {
					e.preventDefault();
					window.tinymce.activeEditor.undoManager.ignore(() => {
						window.tinymce.activeEditor.execCommand('mceSearchReplaceToolbar', false, false, {
							skip_undo: true,
						});
					});
				}
			};

			// keyboard handling for the replace text box
			const replaceKeyboardHandler = function (e) {
				if (
					!window.tinymce.isIE8 &&
					(e.ctrlKey || (window.tinymce.isMac && e.metaKey)) &&
					e.which === 70
				) {
					// prevent browser search from kicking in
					e.preventDefault();
				} else if (e.which === 13) {
					e.preventDefault();

					const ignore = window.tinymce.activeEditor.undoManager.ignore(() => {
						window.tinymce.activeEditor.execCommand(
							'mceConfSearch',
							false,
							{
								backwards: false,
								onFound: focusOnReplaceTextBox,
								onNotFound: focusOnFindTextBox,
							},
							{ skip_undo: true },
						);
					});

					mceConfreplace(focusOnReplaceTextBox, focusOnFindTextBox, ignore);
				} else if (e.which === 27) {
					e.preventDefault();
					window.tinymce.activeEditor.undoManager.ignore(() => {
						window.tinymce.activeEditor.execCommand('mceSearchReplaceToolbar', false, false, {
							skip_undo: true,
						});
					});
				}
			};

			// The toolbar is dependent on the browser so first create all the components before
			// button together the full button array
			const findTextBox = new Editor.Toolbar.Components.TextBox({
				id: 'search-toolbar-find-text',
				text: editor.translate('tinymce.searchreplace_dlg.findlabel'),
				name: 'find',
				keydown: findKeyboardHandler,
				cssClass: 'toolbar-find-input',
			});

			const replaceTextBox = new Editor.Toolbar.Components.TextBox({
				id: 'search-toolbar-replace-text',
				text: editor.translate('tinymce.searchreplace_dlg.replacelabel'),
				name: 'replace',
				keydown: replaceKeyboardHandler,
				cssClass: 'toolbar-replace-input',
			});

			const previousButton = new Editor.Toolbar.Components.TextButton({
				text: editor.translate('tinymce.searchreplace_dlg.findprevious'),
				click() {
					const parameters = {
						backwards: true,
						onFound() {
							top.focus();
							focusOnButton('search-toolbar-find-previous-button');
						},
						onNotFound: focusOnFindTextBox,
					};
					editor.undoManager.ignore(() => {
						editor.execCommand('mceConfSearch', false, parameters, {
							skip_undo: true,
						});
					});
				},
				textClass: 'search-toolbar-find-previous-button',
			});

			const nextButton = new Editor.Toolbar.Components.TextButton({
				text: window.tinymce.Env.ie
					? editor.translate('tinymce.searchreplace_dlg.findlabel')
					: editor.translate('tinymce.searchreplace_dlg.findnext'),
				click() {
					const parameters = {
						backwards: false,
						onFound() {
							top.focus();
							focusOnButton('search-toolbar-find-next-button');
						},
						onNotFound: focusOnFindTextBox,
					};
					editor.undoManager.ignore(() => {
						editor.execCommand('mceConfSearch', false, parameters, {
							skip_undo: true,
						});
					});
				},
				textClass: 'search-toolbar-find-next-button',
			});

			const replaceButton = new Editor.Toolbar.Components.TextButton({
				text: editor.translate('tinymce.searchreplace_dlg.replace'),
				click() {
					mceConfreplace(() => {
						top.focus();
						focusOnButton('search-toolbar-replace-button');
					}, focusOnFindTextBox);
				},
				textClass: 'search-toolbar-replace-button',
			});

			const mceConfreplace = (onFound, onNotFound, onInactive) => {
				if (!window.Confluence.Editor.searchManager) {
					return;
				}

				if (
					!window.tinymce.activeEditor.plugins.customtoolbar.isToolbarButtonEnabled(
						'search-toolbar-replace-button',
					)
				) {
					onInactive && onInactive();
				} else {
					window.Confluence.Editor.searchManager.replace(onFound, onNotFound);
				}
			};

			const replaceAllButton = new Editor.Toolbar.Components.TextButton({
				text: editor.translate('tinymce.searchreplace_dlg.replaceall'),
				click() {
					const parameters = {
						onReplaced: focusOnEditor,
						onNotReplaced: focusOnFindTextBox,
					};
					editor.undoManager.transact(() => {
						editor.execCommand('mceConfReplaceAll', false, parameters);
					});
				},
				textClass: 'search-toolbar-replaceall-button',
			});

			const closeButton = new Editor.Toolbar.Components.Button({
				text: editor.translate('tinymce.searchreplace_dlg.close'),
				iconClass: 'icon-close',
				click() {
					editor.undoManager.ignore(() => {
						editor.execCommand('mceConfSearchClose', false, null);
					});
				},
			});

			const buttons = [
				new Editor.Toolbar.Components.Group([closeButton], {
					groupClass: 'close',
				}),
				new Editor.Toolbar.Components.Group([findTextBox, replaceTextBox], {
					groupClass: 'no-separator',
				}),
				new Editor.Toolbar.Components.Group(
					window.tinymce.Env.ie ? [nextButton] : [previousButton, nextButton],
				),
				new Editor.Toolbar.Components.Group([replaceButton, replaceAllButton]),
			];

			return {
				Buttons: buttons,
			};
		},
	};
};

export default function () {
	domBind(document, 'initContextToolbars.Toolbar', (e, editor) => {
		window.Confluence.Editor.searchToolbar = initToolbar().initContextToolbars(e, editor);
	});
}
